import type { AnyAction, Reducer, StateFromReducersMapObject } from "redux";
import { combineReducers } from "redux";
import answer from "./answer";
import company from "./company";
import customers from "./customers";
import models from "./models";
import projects from "./projects";
import questions from "./questions";
import sla from "./sla";
import themes from "./themes";

type AsyncReducers = Record<string, Reducer>;
const staticReducers = {
  customers,
  company,
  projects,
  themes,
  models,
  questions,
  answer,
  sla,
};
export type RootReducerState = StateFromReducersMapObject<
  typeof staticReducers
>;

export const CLEAR_COMPANY_SCOPED_DATA = "session/clearCompanyScopedData";
export const clearCompanyScopedData = () => ({
  type: CLEAR_COMPANY_SCOPED_DATA,
});

const rootReducer =
  (asyncReducers: AsyncReducers = {}) =>
  (state: RootReducerState | undefined, action: AnyAction) => {
    const combinedReducer = combineReducers({
      ...staticReducers,
      ...asyncReducers,
    });
    return combinedReducer(
      action.type === CLEAR_COMPANY_SCOPED_DATA ? undefined : state,
      action,
    );
  };

export default rootReducer;
